<template>
  <div class="text-center" id="schol-header">
    <h1>{{organization_name.toUpperCase()}}</h1>
    <h3>{{scholarship_name}}</h3>
    <div class="text-center" id="deadline">{{this.enrollment_period.title}} <b>{{this.enrollment_period.date}}</b></div>
  </div>
</template>

<script>
export default {
  props: {
    organization_name: String,
    scholarship_name: String,
    enrollment_period: Object
  },
  components:{
  },
  data(){
    return {
    }
  },
  mounted(){
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>

#schol-header {
  margin-top: 2em;
  margin-bottom: 2em;
}

#deadline {
  font-size: 1.5em;
}

#schol-header h1 {
  color: #9f9f9f;
}

#schol-header h3 {
  color: #5f5f5f;
}

</style>
